// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3yQmr","footer":"ModalFilter_footer__Z2URP"};